module.exports = __webpack_public_path__ + "img/8.1cdb2d83.jpg";